import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericRepository } from '../generic-repository/GenericRepository';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { POSStrings } from '../../models/POSStrings/pos-strings.model';
import { IPOSStringsRepository } from './IPOSStringsRepository';

@Injectable({
  providedIn: 'root',
})
export class POSStringsRepository
  extends GenericRepository<POSStrings>
  implements IPOSStringsRepository
{
  private apiBase: string;

  // constructor(protected _http: HttpClient) {
  //   const base = environment.urlAddress.endsWith('/')
  //     ? environment.urlAddress
  //     : environment.urlAddress + '/';

  //   super(_http, 'api/POSStrings/', base);

  //   this.apiBase = base + 'api/POSStrings/';
  // }

  private static getBaseUrl(): string {
    return environment.urlAddress.endsWith('/')
      ? environment.urlAddress
      : environment.urlAddress + '/';
  }

  constructor(protected _http: HttpClient) {
    super(_http, 'api/POSStrings/', POSStringsRepository.getBaseUrl());
    this.apiBase = POSStringsRepository.getBaseUrl() + 'api/POSStrings/';
  }

  GetAll(
    currentPage: number,
    recordsPerPage: number,
    filterText: string,
  ): Observable<any> {
    filterText = filterText ? filterText.split('/').join('~') : '|';

    return this._http
      .get(
        this.apiBase +
          'SelectAll/' +
          currentPage +
          '/' +
          recordsPerPage +
          '/' +
          filterText,
        this.httpOptions,
      )
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  LoadRec(smartAppStringID: number): Observable<any> {
    return this._http
      .get(this.apiBase + 'GetRec/' + smartAppStringID, this.httpOptions)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  SaveRec(item: POSStrings): Observable<any> {
    return this.PostData('SaveRec', item).pipe(
      map(this.extractData),
      catchError(this.handleError),
    );
  }
}
